import { z } from 'zod';

const EnvSchema = z.object({
  VITE_API_BASE_URL: z.string().url(),
  VITE_AWS_REGION: z.string().min(1).default('us-east-1'),
  VITE_COGNITO_USER_POOL_ID: z.string().min(1),
  VITE_COGNITO_CLIENT_ID: z.string().min(1),
});

export type Env = z.infer<typeof EnvSchema>;

let cached: Env | undefined;

/**
 * Parses Vite env vars on first call. Throws if any required `VITE_*` is
 * missing — the app fails loud at startup rather than silently trying to
 * talk to a nonexistent Cognito pool.
 *
 * Lazy so modules importing this file in a non-browser context (tests,
 * future SSR) don't crash unless they actually ask for the env.
 */
export function getEnv(): Env {
  if (cached) return cached;
  cached = EnvSchema.parse({
    VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
    VITE_AWS_REGION: import.meta.env.VITE_AWS_REGION,
    VITE_COGNITO_USER_POOL_ID: import.meta.env.VITE_COGNITO_USER_POOL_ID,
    VITE_COGNITO_CLIENT_ID: import.meta.env.VITE_COGNITO_CLIENT_ID,
  });
  return cached;
}
